export default {
    registerPromo1Title: "Promo 1",
    registerPromo1Body:  "Promo inhoud",
    registerPromo2Title: "Promo 2",
    registerPromo2Body:  "Promo inhoud"
};